import { NgModule } from '@angular/core';
import { PollHeaderComponent } from 'src/app/core/headers/poll-header/poll-header.component';
import { PollLayoutComponent } from './poll-layout.component';
import { AdmPollsComponent } from 'src/app/modules/admin/pages/crud/adm-polls/adm-polls.component';
import { MaterialModule } from 'src/app/material-module';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from 'src/app/modules/components/login/login.component';
import { AdmPollEditComponent } from 'src/app/modules/admin/pages/crud/adm-poll-edit/adm-poll-edit.component';
import { PollFieldsComponent } from 'src/app/shared/admin/widgets/poll-fields/poll-fields.component';
import { AuthGuard } from 'src/app/core/auth/auth.guard';
import { PollStatisticsComponent } from 'src/app/modules/admin/pages/poll-statistics/poll-statistics.component';
import { PieComponent } from 'src/app/shared/admin/widgets/stats/pie/pie.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { BarVertComponent } from 'src/app/shared/admin/widgets/stats/bar-vert/bar-vert.component';
import { TagCloudModule } from 'angular-tag-cloud-module';
import { WordCloudComponent } from 'src/app/shared/admin/widgets/stats/word-cloud/word-cloud.component';


const routes: Routes = [
            {
                path: '',
                component: AdmPollsComponent,
                canActivate: [AuthGuard],
                data: { roles: ['creator','superadmin']},
            },
            {
                path: 'edit/:id',
                component: AdmPollEditComponent,
                canActivate: [AuthGuard],
                data: { roles: ['creator','superadmin'] }
            },
            {
                path: 'answers/:id',
                component: PollStatisticsComponent,
                canActivate: [AuthGuard],
                data: { roles: ['creator','superadmin'] }
            }           
          ]

@NgModule({
    declarations: [
        PollLayoutComponent,
        PollHeaderComponent,
        AdmPollsComponent,
        AdmPollEditComponent,
        PollFieldsComponent,
        PollStatisticsComponent,
        PieComponent,
        BarVertComponent,
        WordCloudComponent
    ],
    entryComponents: [
        LoginComponent,
    ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        NgxChartsModule,
        TagCloudModule
    ],
    
    providers: [
    ],
    exports: [
        PollLayoutComponent
    ]
  })
  export class PollLayoutModule { }